/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import { connect } from "react-redux";
import React, { useState, useEffect, useRef } from "react";
import classes from "../checkout.module.css";
import Input from "../../../../component/inputpm";
import InputPhone from "../../../../component/inputPhone";
// import Select from '../../../../component/select';
import Grid from "@mui/material/Grid";
import Button from "../../../../component/button";
import validator from "../../../../helper/validator";
import stateCode from "../../../../helper/stateCode";
import Loader from "../../../../component/loader";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import BusApiCall from "../../../../helper/axios.js";
import constants from "../../../../helper/constants";
import { withTranslation } from "react-i18next";
import Breadcrumb from "../../../../component/breadcrumb";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import AddressDetails from "../../../pm/customer/addressDetails";
import PaymentDetails from "../../../pm/customer/paymentDetails";

import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import CardPaymentIcon from "react-payment-icons";
import actionTypes from "../../../../store/actions";
import { Card, InputLabel } from "@mui/material";
import Draggable from "react-draggable";
import { getStatesList } from "../../../../helper/getStateList.js";
import StepperNew from "../../../../component/stepper/stepperNew";
import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromRaw,
  Modifier,
} from "draft-js";
// import TextEditor from "../../../../component/richTextEditor/index.js";
import TiptapEditor from "../../../../component/richTextEditor/TiptapEditor.js";
import { getDraftContentStats } from "../../../../component/richTextEditor/getContentStats.js";
// import { makeStyles } from '@mui/styles';
import UriEncode from "../../../../component/uriEncode/uriEncode.js";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { formatNumber } from "../../../../helper/numberFormatter.js";
import SearchUsersDialog from "./searchUsersDialog.js";

const CustomerDetails = (props) => {
  const t = props.t;
  const navigate = useNavigate();
  const countriesList = props.countriesList;
  const loggedInUserId = props.loggedInUserId;
  // Customer form initial data
  const [details, setDetails] = useState({
    ban: "",
    accountName: "",
    isManaged: false,
    firstName: "",
    lastName: "",
    officePhone: "",
    mobilePhone: "",
    email: "",
    billingCloseDay: "1",
    facilityNamePrefix: "",
    custCodeAvailable: false,
    createdByUser: loggedInUserId,

    shipping: {
      attention: "",
      phone: "",
      street1: "",
      street2: "",
      city: "",
      state: "",
      zip: "",
      country: props.defaultCountry,
    },
    billing: {
      attention: "",
      phone: "",
      street1: "",
      street2: "",
      city: "",
      state: "",
      zip: "",
      country: props.defaultCountry,
    },
    paymentMethod: [],
  });

  const [isSame, setIsSame] = useState(false);
  const [newBan, setNewBan] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [selected, setSelected] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);
  const [disableBillingDay, setBillingDay] = useState(false);
  const [bread, setBread] = useState([]);

  const [billingDetails, setBillingDetails] = useState();
  const [creditCardDetails, setCreditCardDetails] = useState();
  const [eftAccountDetails, setEftAccountDetails] = useState();
  const [shippingDetails, setShippingDetails] = useState();
  const [isManagedRequired, setIsManagedRequired] = useState("true");

  const [billingStateList, setBillingStateList] = useState([]);
  const [shippingStateList, setShippingStateList] = useState([]);

  const [activeStep, setActiveStep] = useState(0);
  const [steps, setSteps] = useState([]);
  const [modules, setModules] = useState({});
  const [partialLoading, togglePartialLoading] = useState(false);
  const [invalidBan, setInvalidBan] = useState(false);
  const [success, setSuccess] = useState({});
  const [sectorsList, setSectorsList] = useState([]);

  // const useStyles = makeStyles({
  //     resizablePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 640,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '60vw',
  //     }
  // });
  // const classess = useStyles();

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  useEffect(() => {
    fetchData();
    initializeCardData();
    setStateListChange(props.defaultCountry, "billing");
    setStateListChange(props.defaultCountry, "shipping");
    if (props.manageCustomer && props.disableBillingDay) {
      setBillingDay(true);
    }
    if (props.sectorsList && props.sectorsList.length > 0) {
      var tempObj = {
        target: {
          name: "sector",
          value: props.sectorsList[0].id,
        },
      };
      setRoleAndSector(tempObj);
      setSectorsList(props.sectorsList);
    }
  }, []);

  useEffect(() => {
    if (modules && Object.keys(modules).length > 0) {
      const newSteps = getSteps();
      setSteps(newSteps);
    }
  }, [modules]);

  const fetchData = () => {
    let eftAccountList = [];
    let creditCardList = [];
    var modules = JSON.parse(localStorage.getItem("modules"));
    if (modules) {
      setModules(modules);
    }
    setSteps(getSteps());
    Promise.all([
      BusApiCall(
        "GET",
        `${constants.busInternalUrl}/passthru/GET_PARTY_CONFIGS/endpoint`,
        {},
      ),
      BusApiCall("GET", `${constants.busV4Url}/myProfile`),
      BusApiCall("GET", `${constants.busInternalUrl}/customers`),
    ])
      .then((res) => {
        let isManagedRequired = res[0].data["party.managed.enabled"]
          ? res[0].data["party.managed.enabled"]
          : "true";
        setIsManagedRequired(isManagedRequired);

        let myProfile = res[1].data;
        setBillingDetails(myProfile.billing);
        setShippingDetails(myProfile.shipping);

        //set the 0'th for the Ecommerce Customer //TODO : sales channel
        details.billing = { ...myProfile.billing[0] };
        details.shipping = { ...myProfile.shipping[0] };
        details.billing.phone = "";
        details.shipping.phone = "";

        myProfile.paymentMethods.map((method, i) => {
          if (method.bankName) {
            eftAccountList.push({ ...method });
          } else if (method.cardType) {
            creditCardList.push({ ...method });
          }

          //set primary payment method  //TODO : sales channel (done for credit cards)
          if (method.primary) {
            details.paymentMethod.creditCards = [method];
            details.paymentInstrumentsMap = {
              creditCard: { ...method },
            };
          }
          if (i === myProfile.paymentMethods.length - 1) {
            setCreditCardDetails(creditCardList);
            setEftAccountDetails(eftAccountList);
          }
        });

        //get customer list
        let list = res[2].data.customers.map((a) => {
          return {
            ...a,
            label: `${t("BAN")} #${a.ban} - ${a.accountName}`,
            value: a.ban,
            paymentMethod: a.paymentMethod ? JSON.parse(a.paymentMethod) : [],
          };
        });
        list.unshift({
          label: t("ADD_NEW_BAN"),
          value: "",
        });
        setCustomers(list);
        if (props.selectedPromoBan !== "" && props.selectedPromoBan !== "all") {
          for (let i = 0; i < list.length; i++) {
            if (list[i].partyId === props.selectedPromoBan) {
              onSelect(list[i]);
              break;
            }
          }
        }
        if (props.customerDetails.ban) {
          const ban = props.customerDetails.ban;
          const index = list.findIndex((a) => a.ban === ban);
          if (index > -1) {
            if (list[index].paymentMethod.creditCards.length > 0) {
              props.customerDetails.paymentMethod = list[index].paymentMethod;
              delete props.customerDetails.paymentInstrumentsMap;
            }
            props.customerDetails.billing =
              props.customerDetails.customerEmployeeDetails.billing;
            props.customerDetails.shipping =
              props.customerDetails.customerEmployeeDetails.shipping;
            setSelected(list[index]);
            setDetails(props.customerDetails);
            if (props.customerDetails.customerEmployeeDetails) {
              setBillingDetails(
                props.customerDetails.customerEmployeeDetails.billing,
              );
              setShippingDetails(
                props.customerDetails.customerEmployeeDetails.shipping,
              );
              setCreditCardDetails(
                props.customerDetails.customerEmployeeDetails.creditCardDetails,
              );
              setEftAccountDetails(
                props.customerDetails.customerEmployeeDetails.eftAccountDetails,
              );
            }

            //set data for multiple seclection
          }
        }
        let tempBread = [
          {
            title: `${!props.oldOrder ? t("CHECKOUT") : t("UPDATE")}: ${"Business Account"} #${details.ban}`,
            url: "/checkout",
          },
        ];
        setBread(tempBread);
        // setStateListChange(props.defaultCountry, 'shipping');
        // setStateListChange(props.defaultCountry, 'billing');
        setLoading(false);
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
        }
        setLoading(false);
      });
  };

  const initializeCardData = () => {
    let date = new Date();
    let currentYear = date.getFullYear();
    setData({ ...cardData, expireYear: currentYear });
    let years = [];
    years.push(currentYear);
    for (var i = 0; i < 20; i++) {
      currentYear++;
      years.push(currentYear);
    }
    setYears(years);
  };

  function getSteps() {
    if (props.screenType && props.screenType === "leads") {
      return ["Lead Details"];
    } else {
      if (modules.module_payment === "enabled") {
        return ["Account Details", "Contact Details", "Payment Details"];
      } else {
        return ["Account Details", "Contact Details"];
      }
    }
  }

  const setStateListChange = (country, type) => {
    togglePartialLoading(true);
    getStatesList(country)
      .then((res) => {
        if (type === "shipping") {
          setShippingStateList(res);
          setDetails({
            ...details,
            shipping: {
              ...details.shipping,
              country: country,
              state: res.length > 0 ? res[0].id : "",
            },
          });
        }
        if (type === "billing") {
          setBillingStateList(res);
          setDetails({
            ...details,
            billing: {
              ...details.billing,
              country: country,
              state: res.length > 0 ? res[0].id : "",
            },
          });
        }
        togglePartialLoading(false);
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(props.t("FAILED_TO_LOAD_STATES"), false);
        }
        togglePartialLoading(false);
      });
  };

  // Select Old Customer / Add customer
  const onSelect = (obj) => {
    if (obj.ban) {
      setBillingDay(true);
    } else {
      setBillingDay(false);
    }
    let shipping = obj.shipping;
    let billing = obj.billing;
    let data = {
      ban: obj.ban ? obj.ban : "",
      accountName: obj.accountName ? obj.accountName : "",
      isManaged: obj.isManaged ? obj.isManaged : false,
      firstName: obj.firstName ? obj.firstName : "",
      lastName: obj.lastName ? obj.lastName : "",
      officePhone: obj.officePhone ? obj.officePhone : "",
      mobilePhone: obj.mobilePhone ? obj.mobilePhone : "",
      email: obj.email ? obj.email : "",
      billingCloseDay: obj.billingCloseDay ? "" + obj.billingCloseDay : "" + 1,
      createdByUser: obj.createdByUser
        ? obj.createdByUser
        : props.loggedInUserId,
    };
    if (shipping) {
      data.shipping = {
        attention: shipping.attention,
        phone: "",
        //phone: shipping.phone,
        street1: shipping.street1,
        street2: shipping.street2,
        city: shipping.city,
        state: shipping.state,
        zip: shipping.zip,
        country: shipping.country,

        postalMechId: shipping.postalMechId,
        phoneMechId: shipping.phoneMechId,
      };
    } else {
      data.shipping = {
        attention: "",
        phone: "",
        street1: "",
        street2: "",
        city: "",
        state: "",
        zip: "",
        country: props.defaultCountry,
      };
    }
    if (billing) {
      data.billing = {
        attention: billing.attention,
        phone: "",
        //phone: billing.phone,
        street1: billing.street1,
        street2: billing.street2,
        city: billing.city,
        state: billing.state,
        zip: billing.zip,
        country: billing.country,

        postalMechId: billing.postalMechId,
        phoneMechId: billing.phoneMechId,
      };
    } else {
      data.billing = {
        attention: "",
        phone: "",
        street1: "",
        street2: "",
        city: "",
        state: "",
        zip: "",
        country: props.defaultCountry,
      };
    }
    if (obj.value === "") {
      setNewBan(true);
    }
    data.paymentMethod = obj.paymentMethod ? obj.paymentMethod : "";
    setSelected(obj);
    setDetails(data);

    //set customers shipping address
    if (
      props.loggedInUserType != "ECOMMERCE_CUSTOMER" ||
      props.loggedInUserType != "ECOMMERCE_ADMIN"
    ) {
      props.customerDetails.partyId = obj.partyId;
      props.customerDetails.ban = obj.ban;
      props.customerDetails.accountName = obj.accountName;
      if (obj.customerEmployeeDetails) {
        setBillingDetails(obj.customerEmployeeDetails.billing);
        setShippingDetails(obj.customerEmployeeDetails.shipping);
        setCreditCardDetails(obj.customerEmployeeDetails.creditCardDetails);
        setEftAccountDetails(obj.customerEmployeeDetails.eftAccountDetails);
      } else {
        setBillingDetails([]);
        setShippingDetails([]);
        setCreditCardDetails([]);
        setEftAccountDetails([]);
      }
    }
  };

  // Update billing address
  const setBilling = (e) => {
    setDetails({
      ...details,
      billing: {
        ...details.billing,
        [e.target.name]: e.target.value,
      },
    });
  };

  // Set shipping address
  const setShipping = (e) => {
    setDetails({
      ...details,
      shipping: {
        ...details.shipping,
        [e.target.name]: e.target.value,
      },
    });
  };

  // Validate basic BAN form details
  const validateForm = () => {
    for (let key in details) {
      if (
        ((key === "ban" && details.custCodeAvailable) ||
          key === "accountName" ||
          key === "email") &&
        //|| key === 'firstName' || key === 'lastName' || key === 'officePhone'
        (props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
          props.loggedInUserType !== "ECOMMERCE_ADMIN")
      ) {
        if (!details[key]) {
          return false;
        }
      }
    }
    return true;
  };

  // Validate Billing/Shipping address
  const validateAddress = (data) => {
    for (let key in data) {
      if (
        key === "attention" ||
        key === "city" ||
        key === "country" ||
        key === "state" ||
        key === "street1" ||
        key === "zip"
      ) {
        if (!data[key]) {
          return false;
        }
      }
    }
    return true;
  };

  // Validate Phone nUmbers
  // const validatePhoneNo = (val) => {
  //     if (val) {
  //         // var pattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  //         var pattern = /^\d+$/;
  //         return pattern.test(val)
  //     }
  //     return true
  // }

  const validatePhoneNo = (mobileNumber) => {
    const mobileNumberRegex =
      /^[+]?[0-9]{1,3}[-\s.]?[0-9]{1,3}[-\s.]?[0-9]{1,4}$|^[\+][1][-][0-9]{1,3}[-\s.]?[0-9]{1,3}[-\s.]?[0-9]{1,4}$/;
    if (!mobileNumberRegex.test(mobileNumber)) {
      return false;
    }
    return true;
  };

  // Check validations on Next click
  const onNext = async (step) => {
    if (invalidBan) {
      return;
    }
    // const content = notesState.getCurrentContent();
    const content = customerNote;
    const error = {};
    if (step === 0) {
      if (!details.accountName) {
        error.accountName = t("ACCOUNT_NAME_IS_REQUIRED");
      } else if (details.accountName.trim().length === 0) {
        error.accountName = t("ACCOUNT_NAME_IS_REQUIRED");
      }
      if (details.custCodeAvailable && !details.ban) {
        error.ban = t("ACCOUNT_NUMBER_IS_REQUIRED");
      }
      if (modules.module_inventory === "enabled") {
        if (!details.isManaged) {
          details.facilityNamePrefix = "";
        } else {
          if (!details.facilityNamePrefix) {
            error.facilityNamePrefix = t("FACILITY_NAME_PREFIX_IS_REQUIRED");
          }
        }
      }
      if (props.showMyCustomers) {
        if (!details.createdByUser || details.createdByUser.trim() === "") {
          error.createdByUser = t("CREATED_BY_IS_REQUIRED");
        }
      }
      // if (!details.firstName) {
      //     error.firstName = t('FIRST_NAME_IS_REQUIRED');
      // }
      // if (!details.lastName) {
      //     error.lastName = t('LAST_NAME_IS_REQUIRED');
      // }

      if (
        modules.module_customer_billing === "enabled" &&
        props.screenType !== "leads"
      ) {
        if (!details.billing.attention) {
          error.attention = t("ATTENTION_IS_REQUIRED");
        }
        if (!details.billing.street1) {
          error.street1 = t("STREET1_IS_REQUIRED");
        }
        if (!details.billing.state) {
          error.state = t("STATE_IS_REQUIRED");
        }
        // if (!details.billing.zip) {
        //     error.zip = t("ZIP_IS_REQUIRED");
        // }
        if (!details.billing.city) {
          error.city = t("CITY_IS_REQUIRED");
        }
        if (details.billing.phone) {
          if (!validatePhoneNo(details.billing.phone)) {
            error.phone = t("PHONE_IS_INVALID");
          }
        }
      }
      if (!isSame && props.screenType !== "leads") {
        if (!details.shipping.attention) {
          error.attention_shipping = t("ATTENTION_IS_REQUIRED");
        }
        if (props.screenType && props.screenType !== "leads") {
          if (!details.shipping.street1) {
            error.street1_shipping = t("STREET1_IS_REQUIRED");
          }
        }
        if (!details.shipping.state) {
          error.state_shipping = t("STATE_IS_REQUIRED");
        }
        // if (!details.shipping.zip) {
        //     error.zip_shipping = t("ZIP_IS_REQUIRED");
        // }
        if (!details.shipping.city) {
          error.city_shipping = t("CITY_IS_REQUIRED");
        }
        if (details.shipping.phone) {
          if (!validatePhoneNo(details.shipping.phone)) {
            error.phone_shipping = t("PHONE_IS_INVALID");
          }
        }
      }

      // setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
    if (step === 1) {
      if (details.officePhone) {
        //     error.officePhone = t('OFFICE_PHONE_IS_REQUIRED');}
        if (!validatePhoneNo(details.officePhone)) {
          error.officePhone = t("PHONE_IS_INVALID");
        }
      }
      if (details.mobilePhone) {
        if (!validatePhoneNo(details.mobilePhone)) {
          error.mobilePhone = t("PHONE_IS_INVALID");
        }
      }
      if (!details.email) {
        error.email = t("EMAIL_IS_REQUIRED");
      } else if (!/\S+@\S+\.\S+/.test(details.email)) {
        error.email = t("EMAIL_IS_INVALID");
      }
    }
    if (modules.module_payment === "enabled" && step === 3) {
      if (addPayment) {
        if (selectedPaymentOption === "creditCard") {
          if (!cardData.cardNumber) {
            error.cardNumber = t("CARD_NUMBER_IS_REQUIRED");
          }
          if (!cardData.firstNameOnCard) {
            error.firstNameOnCard = t("FIRST_NAME_IS_REQUIRED");
          }
          if (!cardData.lastNameOnCard) {
            error.lastNameOnCard = t("LAST_NAME_IS_REQUIRED");
          }
          if (!cardData.expireMonth) {
            error.expireMonth = t("EXPIRY_MONTH_IS_REQUIRED");
          }
          if (!cardData.expireYear) {
            error.expireYear = t("EXPIRY_YEAR_IS_REQUIRED");
          }
          if (isCardExpired(cardData.expireMonth, cardData.expireYear)) {
            error.cardNumber = t("CARD_IS_EXPIRED");
          }
        } else if (selectedPaymentOption === "bankAccount") {
          if (!bankAccount.bankName) {
            error.bankName = t("BANK_NAME_IS_REQUIRED");
          }
          if (!bankAccount.nameOnAccount) {
            error.nameOnAccount = t("NAME_ON_ACCOUNT_IS_REQUIRED");
          }
          if (!bankAccount.routingNumber) {
            error.routingNumber = t("ROUTING_NUMBER_IS_REQUIRED");
          }
          if (!bankAccount.accountNumber) {
            error.accountNumber = t("ACCOUNT_NUMBER_IS_REQUIRED");
          }
        } else {
          error.selectPaymentMethod = t("SELECT_PAYMENT_METHOD_TO_ADD");
        }
      } else if (!addPayment) {
        setData({
          nameOnCard: "",
          cardType: "",
          cardNumber: "",
          expireMonth: "01",
          expireYear: "" + new Date().getFullYear(),
          isPrimary: true,
          firstNameOnCard: "",
          lastNameOnCard: "",
          cardLogoId: "",
        });
        setBankAccountData({
          bankName: "",
          routingNumber: "",
          nameOnAccount: "",
          accountNumber: "",
        });
      }
    }
    if (props.screenType && props.screenType === "leads") {
      if (getDraftContentStats(content, 'chars') === 0) {
        error.notesError = t("OPPORTUNITY_DESCRIPTION_IS_REQUIRED");
      }
      if (!details.firstName) {
        error.firstName = t("FIRST_NAME_IS_REQUIRED");
      }
      if (!details.lastName) {
        error.lastName = t("LAST_NAME_IS_REQUIRED");
      }
      if (!sectorData.role) {
        error.role = t("ROLE_IS_REQUIRED");
      }
      if (!details.email) {
        error.email = t("EMAIL_IS_REQUIRED");
      } else if (!/\S+@\S+\.\S+/.test(details.email)) {
        error.email = t("EMAIL_IS_INVALID");
      }
      if (!details.mobilePhone) {
        error.mobilePhone = t("PHONE_IS_REQUIRED");
      } else if (details.mobilePhone) {
        if (!validatePhoneNo(details.mobilePhone)) {
          error.mobilePhone = t("PHONE_IS_INVALID");
        }
      }
      if (!details.shipping.city) {
        error.city_shipping = t("CITY_IS_REQUIRED");
      }
    }
    setError(error);
    // if (!validatePhoneNo(details.officePhone)) {
    //     props.validator(t('OFFICE_PHONE_NUMBER_IS_NOT_VALID'), false);
    // }
    // else if (!validatePhoneNo(details.mobilePhone)) {
    //     props.validator(t('MOBILE_PHONE_NUMBER_IS_NOT_VALID'), false);
    // }
    // else if (!validatePhoneNo(details.billing.phone)) {
    //     props.validator(t('BILLING_PHONE_NUMBER_IS_NOT_VALID'), false);
    // }
    // else if (!isSame && !validatePhoneNo(details.shipping.phone)) {
    //     props.validator(t('SHIPPING_PHONE_NUMBER_IS_NOT_VALID'), false);
    // } else if (props.loggedInUserType !== "ECOMMERCE_CUSTOMER" && !validateBanOnBlur()) {
    // } else if (!validateForm()) {
    //     props.validator(t('MANDATORY_FIELDS_MESSAGE'), false);
    // } else if (props.loggedInUserType !== "ECOMMERCE_CUSTOMER" && !validator.Email(details.email)) {
    //     props.validator(t('CONTACT_EMAIL_IS_INVALID'), false);
    // } else if (!validateAddress(details.billing)) {
    //     props.validator(t('MANDATORY_FIELDS_MESSAGE'), false);
    // } else if (!isSame) {
    //     if (!validateAddress(details.shipping)) {
    //         props.validator(t('MANDATORY_FIELDS_MESSAGE'), false);
    //     }
    if (Object.keys(error).length === 0) {
      if (props.screenType && props.screenType === "leads") {
        if (props.showMyCustomers) {
          const isValid = await verifyUserId();
          if (!isValid) {
            return;
          }
        }
        submitForm();
      } else {
        if (modules.module_payment === "enabled") {
          if (step === 2) {
            // If form is valid
            submitForm();
          } else {
            // setActiveStep((prevActiveStep) => prevActiveStep + 1);
            goNext();
          }
        } else {
          if (step === 1) {
            // If form is valid
            submitForm();
          } else {
            if (step === 0) {
              if (props.showMyCustomers) {
                const isValid = await verifyUserId();
                if (!isValid) {
                  return;
                }
              }
              // setActiveStep((prevActiveStep) => prevActiveStep + 1);
              goNext();
            } else {
              // setActiveStep((prevActiveStep) => prevActiveStep + 1);
              goNext();
            }
          }
        }
      }
    }
  };

  const goNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  //check card validity
  const isCardExpired = (expireMonth, expireYear) => {
    const now = new Date();
    const expiryDate = new Date(expireYear, expireMonth - 1, 1);
    return expiryDate < now;
  };

  // Add/Update customer
  const submitForm = () => {
    const ban = details.ban ? validator.Ban(details.ban) : -1;
    // const ban = validator.Ban(details.ban);
    const index = customers.findIndex((a) => a.ban === ban);
    if (index > -1) {
      props.validator(t("DUPLICATE_CUSTOMER_BAN"), false);
      // const data = {
      //     ...customers[index],
      //     ...details,
      // }
      // data.custCodeAvailable = details.custCodeAvailable || false
      // if (isSame) {
      //     let tempShipping = { ...data.shipping }
      //     data.shipping = { ...data.billing }
      //     data.shipping.phoneMechId = tempShipping.phoneMechId;
      //     data.shipping.postalMechId = tempShipping.postalMechId;
      // }
      // if (selectedPaymentOption === 'creditCard') {
      //     if (cardData.nameOnCard && cardData.cardNumber) {
      //         let card = { ...cardData };
      //         card.expireDate = cardData.expireMonth + '/' + cardData.expireYear;
      //         delete card.expireMonth;
      //         delete card.expireYear;
      //         data.paymentInstrumentsMap = {
      //             creditCard: { ...card }
      //         };
      //         if (props.manageCustomer) {
      //             props.addCustomer(data)
      //         } else {
      //             props.next(props.stage, data)
      //         }
      //     } else {
      //         props.validator(t('ALL_FIELDS_ARE_REQUIRED_FOR_CREDIT_CARD'), false)
      //     }
      // } else if (selectedPaymentOption === 'bankAccount') {
      //     if (!bankAccount.bankName || !bankAccount.nameOnAccount || !bankAccount.routingNumber || !bankAccount.accountNumber) {
      //         props.validator(t('ALL_FIELDS_ARE_REQUIRED_FOR_BANK_ACCOUNT'), false)
      //     } else if (bankAccount.routingNumber.length !== 9) {
      //         props.validator(t('INVALID_ROUTING_NUMBER'), false)
      //     } else if (bankAccount.accountNumber.length > 17) {
      //         props.validator(t('INVALID_ACCOUNT_NUMBER'), false)
      //     } else {
      //         data.paymentInstrumentsMap = {
      //             eftAccount: { ...bankAccount }
      //         };
      //         if (props.manageCustomer) {
      //             props.addCustomer(data)
      //         } else {
      //             props.next(props.stage, data)
      //         }
      //     }
      // } else {
      //     if (props.manageCustomer) {
      //         props.addCustomer(data)
      //     } else {
      //         props.next(props.stage, data)
      //     }
      // }
    } else {
      // New customer code goes here
      // Handle payment method here
      let data = { ...details };
      data.custCodeAvailable = details.custCodeAvailable || false;
      if (isSame) {
        let tempShipping = { ...data.shipping };
        data.shipping = { ...data.billing };
        data.shipping.phoneMechId = tempShipping.phoneMechId;
        data.shipping.postalMechId = tempShipping.postalMechId;
      }
      var notesData = {
        basicDetail: {
          customerNote: customerNote,
          localisedCustomerNote: localisedCustomerNote,
        },
      };
      var sectorDataPayload = {
        name: "attrSector",
        description: "",
        value: sectorData.sector,
      };
      var RoleData = {
        name: "attrRole",
        description: "",
        value: sectorData.role,
      };
      if (props.screenType && props.screenType === "leads") {
        data.shipping.country = "";
        data.shipping.street1 = data.shipping.city;
        data.shipping.attention = data.firstName + " " + data.lastName;
        data.billing.country = "";
      }
      if (selectedPaymentOption === "creditCard") {
        if (
          cardData.firstNameOnCard &&
          cardData.lastNameOnCard &&
          cardData.cardNumber
        ) {
          var date = new Date();
          let currentYear = date.getFullYear();
          let currentMonth = date.getMonth();

          if (
            +cardData.expireYear === currentYear &&
            +cardData.expireMonth < currentMonth + 1
          ) {
            props.validator(t("CARD_EXPIRY_MONTH_IS_NOT_VALID"), false);
          } else {
            let card = { ...cardData };
            card.expireDate = cardData.expireMonth + "/" + cardData.expireYear;
            delete card.expireMonth;
            delete card.expireYear;
            data.paymentInstrumentsMap = {
              creditCard: { ...card },
            };

            if (props.manageCustomer) {
              if (props.screenType && props.screenType === "leads") {
                props.addCustomer(data, notesData, sectorDataPayload, RoleData);
              } else {
                props.addCustomer(data);
              }
            } else {
              props.next(props.stage, data);
            }
          }
        } else {
          props.validator(t("ALL_FIELDS_ARE_REQUIRED_FOR_CREDIT_CARD"), false);
        }
      } else if (selectedPaymentOption === "bankAccount") {
        if (
          !bankAccount.bankName ||
          !bankAccount.nameOnAccount ||
          !bankAccount.routingNumber ||
          !bankAccount.accountNumber
        ) {
          props.validator(t("ALL_FIELDS_ARE_REQUIRED_FOR_BANK_ACCOUNT"), false);
        } else if (bankAccount.routingNumber.length !== 9) {
          props.validator(t("INVALID_ROUTING_NUMBER"), false);
        } else if (bankAccount.accountNumber.length > 17) {
          props.validator(t("INVALID_ACCOUNT_NUMBER"), false);
        } else {
          data.paymentInstrumentsMap = {
            eftAccount: { ...bankAccount },
          };
          if (props.manageCustomer) {
            if (props.screenType && props.screenType === "leads") {
              props.addCustomer(data, notesData, sectorDataPayload, RoleData);
            } else {
              props.addCustomer(data);
            }
          } else {
            props.next(props.stage, data);
          }
        }
      } else {
        if (props.manageCustomer) {
          if (props.screenType && props.screenType === "leads") {
            props.addCustomer(data, notesData, sectorDataPayload, RoleData);
          } else {
            props.addCustomer(data);
          }
        } else {
          props.next(props.stage, data);
        }
      }
    }
  };

  const submitCustomerNotes = (ban) => {
    var payload = {
      basicDetail: {
        customerNote: customerNote,
        localisedCustomerNote: localisedCustomerNote,
      },
    };
    // BusApiCall('POST', `${constants.busV44UrlPublic}/customers/${UriEncode(ban)}/notes`, payload).then(res => {

    // }).catch(err => {
    //     // if (err.response && err.response.data && err.response.data.message) {
    //     //     props.setErrorMessage(err.response.data.message, false)
    //     // } else {
    //     //     props.setErrorMessage(props.t('DEFAULT_ERROR_MESSAGE'), false)
    //     // }
    // })
  };
  const submitSectorRole = (partyId, type) => {
    var payload = {};
    if (type === "sector") {
      payload = {
        name: "attrSector",
        description: "",
        value: sectorData.sector,
      };
    }
    if (type === "role") {
      payload = {
        name: "attrRole",
        description: "",
        value: sectorData.role,
      };
    }
    // BusApiCall('POST'`${constants.busV44UrlPublic}/party/${partyId}/attributes`, payload).then(res => {

    // }).catch(err => {

    // })
  };

  // Validate BAN number
  const validateBanNo = (e) => {
    const { t } = props;
    closeErrorMessage("", false);
    // e.target.value = e.target.value.trim();
    const value = e.target.value;
    if (value.trim().length < 21) {
      setDetails({
        ...details,
        [e.target.name]: value.trim(),
      });
    } else {
      props.validator(t("CUSTOMER_BAN_VALIDATION_ERROR_MESSAGE"), false);
    }
  };

  const ifBanExists = (msg) => {
    // Check for duplicate BAN in customers
    const banExists = customers.some(
      (item) =>
        item.ban &&
        item.partyId !== details.partyId &&
        item.ban === details.ban,
    );

    var index = customers.findIndex(
      (item) =>
        item.ban &&
        item.partyId !== details.partyId &&
        item.ban === details.ban,
    );
    if (banExists) {
      setError({
        ...error,
        ban:
          t("BAN_ALREADY_EXISTS_PLEASE_SELECT_BAN_FROM_THE_LIST") +
          ": " +
          (customers[index] ? customers[index].accountName : ""),
      });
      setInvalidBan(true);
    } else if (msg) {
      props.setErrorMessage(msg, true);
    }
    togglePartialLoading(false);
  };

  // Validate BAN on input blur

  const validateBanOnBlur = async () => {
    closeErrorMessage("", false);
    togglePartialLoading(true);
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/customers/${UriEncode(details.ban)}/validate`,
      {},
    )
      .then((res) => {
        if (res && res.data) {
          if (res.data.apiEnabled === "Y") {
            if (
              // res.data.code === 200 &&
              (res.data.status === "Active" || res.data.status === "Qualified")
            ) {
              // BAN exists in ooredoo, allow to create
              // togglePartialLoading(false);
              var tempMsg =
                t("THE_CUST_CODE_IS_ASSOCIATED_WITH_THE_CUSTOMER") +
                ": " +
                res.data.name;
              setInvalidBan(false);
              setError({
                ...error,
                ban: "",
              });
              ifBanExists(tempMsg);
            } else {
              // not allowed
              togglePartialLoading(false);
              setError({
                ...error,
                ban: t("BAN_NOT_FOUND_CANNOT_CREATE_NEW_CUSTOMER"),
              });
              setInvalidBan(true);
            }
          } else {
            setInvalidBan(false);
            setError({
              ...error,
              ban: "",
            });
            ifBanExists();
            // allow to create with natural flow
            // togglePartialLoading(false);
          }
        } else {
          // not allowed
          togglePartialLoading(false);
          setError({
            ...error,
            ban: t("BAN_NOT_FOUND_CANNOT_CREATE_NEW_CUSTOMER"),
          });
          setInvalidBan(true);
        }
      })
      .catch((err) => {
        // not allowed
        // togglePartialLoading(false);
        // setError({
        //     ...error,
        //     ban: t('BAN_NOT_FOUND_CANNOT_CREATE_NEW_CUSTOMER')
        // });
        // setInvalidBan(true);
        console.log("err", err.response.data, err.response.data.message);
        if (err.response && err.response.data && err.response.data.message) {
          // ${err.response.data.detail ? `${err.response.data.detail} : ` : ''}${err.response.data.message || ''}
          var msg = `${err.response.data.detail ? `${err.response.data.detail} : ` : ""}${err.response.data.message || ""}`;
          props.setErrorMessage(msg, false);
        } else {
          props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
        }
        togglePartialLoading(false);
        setInvalidBan(true);
      });
  };

  const handleBanBlur = () => {
    if (details.ban) {
      const trimmedValue = details.ban.trim();
      setDetails({
        ...details,
        ban: trimmedValue,
      });
      if (trimmedValue !== "") {
        validateBanOnBlur();
      }
    }
  };

  // const validateBanOnBlur = () => {
  //     closeErrorMessage('', false)
  //     customers.filter(item => {
  //         if (item.ban) {
  //             if (item.partyId !== details.partyId) {
  //                 if (item.ban === details.ban) {
  //                     props.validator(t('BAN_ALREADY_EXISTS_PLEASE_SELECT_BAN_FROM_THE_LIST'), false)
  //                     return false
  //                 }
  //             }
  //         }
  //     })
  //     // if (details.ban.length !== 9) {
  //     //     props.validator('Customer BAN must be 9 Digit No.', false)
  //     //     return false
  //     // } else {
  //     // }
  //     return true
  // }

  // Close error message
  const closeErrorMessage = () => {
    props.validator("", false);
  };

  // Submit customer details
  const submitCustomerDetails = () => {
    setLoading(true);
    const ban = validator.Ban(details.ban);
    const index = customers.findIndex((a) => a.ban === ban);
    const data = {
      ...customers[index],
      ...details,
    };
    if (isSame) {
      data.shipping = { ...data.billing };
    }
  };

  // Update Customer details
  const updateCustomerDetails = () => {
    if (!validateForm()) {
      props.validator(t("MANDATORY_FIELDS_MESSAGE"), false);
    } else if (!validator.Email(details.email)) {
      props.validator(t("CONTACT_EMAIL_IS_INVALID"), false);
    } else if (
      modules.module_customer_billing === "enabled" &&
      !validateAddress(details.billing)
    ) {
      props.validator(t("MANDATORY_FIELDS_MESSAGE"), false);
    } else if (modules.module_customer_billing !== "enabled" && !isSame) {
      if (!validateAddress(details.shipping)) {
        props.validator(t("MANDATORY_FIELDS_MESSAGE"), false);
      } else {
        submitCustomerDetails();
      }
    } else {
      submitCustomerDetails();
    }
  };

  // Create days list
  const daysArray = () => {
    let days = [];
    for (let i = 1; i < 32; i++) {
      days.push("" + i);
    }
    return days;
  };

  // Add card dailog content
  const [paymentOptions, setPaymentOptions] = useState([
    // { name: 'Add Payment Method', value: 'add' },
    { name: "Credit Card", value: "creditCard" },
    { name: "Bank Account", value: "bankAccount" },
    // { name: 'Electronic Fund Transfer', value: 'electronicFundTransfer' },
  ]);
  const [selectedPaymentOption, setPaymentOption] = useState("");
  const [open, openPaymentDialog] = useState(false);

  const addPaymentMethod = (e) => {
    if (e.target.value !== "add") {
      setData({
        nameOnCard: "",
        cardType: "",
        cardNumber: "",
        expireMonth: "",
        expireYear: "",
        isPrimary: true,
        firstNameOnCard: "",
        lastNameOnCard: "",
        cardLogoId: "",
      });
      setBankAccountData({
        bankName: "",
        routingNumber: "",
        nameOnAccount: "",
        accountNumber: "",
        isPrimary: true,
      });
      setPaymentOption(e.target.value);
      openPaymentDialog(true);
    }
  };

  // Add card form without dialog content

  const months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const [years, setYears] = useState([]);
  const [cardData, setData] = useState({
    nameOnCard: "",
    cardType: "",
    cardNumber: "",
    expireMonth: "",
    expireYear: "",
    isPrimary: true,
    firstNameOnCard: "",
    lastNameOnCard: "",
    cardLogoId: "",
  });

  const onChangeForm = (e) => {
    if (e.target.name === "cardNumber") {
      let cardType = "";
      let cardLogoId = "";

      //American Express
      if (e.target.value[0] === "3") {
        cardLogoId = "amex";
        cardType = "CCT_AMERICANEXPRESS";
      }
      //visa
      else if (e.target.value[0] === "4") {
        cardLogoId = "visa";
        cardType = "CCT_VISA";
      }
      //MasterCard
      else if (e.target.value[0] === "5" || e.target.value[0] === "2") {
        cardLogoId = "mastercard";
        cardType = "CCT_MASTERCARD";
      }
      //others : add a valid message
      else {
        cardLogoId = "";
        cardType = "";
      }
      setData({
        ...cardData,
        [e.target.name]: e.target.value,
        cardType,
        cardLogoId,
      });
    } else {
      setData({
        ...cardData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const [bankAccount, setBankAccountData] = useState({
    bankName: "",
    routingNumber: "",
    nameOnAccount: "",
    accountNumber: "",
    isPrimary: true,
  });

  const changeBankAccount = (e) => {
    setBankAccountData({
      ...bankAccount,
      [e.target.name]: e.target.value,
    });
  };

  const [customerSelectionOptions, setCustomerSelectionOptions] = useState();
  const [openDialog, setDialog] = useState(false);
  const chooseCustomerDetails = (details) => {
    setDialog(true);
    setCustomerSelectionOptions(details);
  };

  const handleClose = (details) => {
    setDialog(false);
  };

  //this is called when a address or payment is selected from the dialog box
  const chooseExistingCustomerDetail = (optedDetails, tab) => {
    optedDetails.phone = ""; //TODO: sent blank for testing
    if (
      props.providerType === "SALES_CHNL_PROVIDER" &&
      (props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
        props.loggedInUserType !== "ECOMMERCE_ADMIN")
    ) {
      //remove this
    }
    if (tab === "0") {
      setDetails({
        ...details,
        shipping: {
          ...optedDetails,
        },
      });
    } else if (tab === "1") {
      setDetails({
        ...details,
        billing: {
          ...optedDetails,
        },
      });
    } else if (tab === "2") {
      if (optedDetails.cardNumber) {
        optedDetails.nameOnCard =
          optedDetails.firstNameOnCard + " " + optedDetails.lastNameOnCard;
        details.paymentMethod = {
          creditCards: [optedDetails],
        };
        details.paymentInstrumentsMap = {
          creditCard: { ...optedDetails },
        };
      } else if (optedDetails.accountNumber) {
        details.paymentMethod = {
          eftAccount: [optedDetails],
        };
        details.paymentInstrumentsMap = {
          eftAccount: { ...optedDetails },
        };
      }
      setDetails({
        ...details,
      });
    }
    setDialog(false);
  };

  const mandatoryMessage = {
    color: "#f44336",
    fontSize: "12px",
    lineHeight: "64px",
    float: "left",
  };

  const [error, setError] = useState({});
  const [addPayment, setAddPayment] = useState(false);
  const addPaymentToggle = (value) => {
    setAddPayment(value);
  };

  const toggleManaged = (value) => {
    setDetails({
      ...details,
      isManaged: value,
    });
  };
  const changeStep = (value) => {
    setActiveStep(value);
  };

  const handleSwitchChange = (event) => {
    setError({});
    setInvalidBan(false);
    setDetails({
      ...details,
      ban: "",
      custCodeAvailable: event.target.checked,
    });
  };

  const verifyUserId = async () => {
    const userId = details.createdByUser.trim();
    if (userId) {
      togglePartialLoading(true);
      try {
        const res = await BusApiCall(
          "GET",
          `${constants.busInternalUrl}/users/verify?userId=${userId}`,
          {},
        );
        if (res && res.data) {
          if (res.data.userExists) {
            setSuccess({
              ...success,
              createdByUser: props.t("USER_ID_VERIFIED"),
            });
            return true;
          } else {
            setError({
              ...error,
              createdByUser: props.t("INVALID_USER_ID"),
            });
            return false;
          }
        }
      } catch (err) {
        if (err.response && err.response.data && err.response.data.message) {
          props.setErrorMessage(err.response.data.message, false);
        } else {
          props.setErrorMessage(props.t("DEFAULT_ERROR_MESSAGE"), false);
        }
        return false;
      } finally {
        togglePartialLoading(false);
      }
    }
    return false;
  };

  // const [notesState, setNotesState] = useState(EditorState.createEmpty());
  const [customerNote, setCustomerNote] = useState(
    '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
  );
  const [localisedCustomerNote, setLocalisedCustomerNote] = useState([
    {
      locale: "en_US",
      text: '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
    },
  ]);
  const onChangeNotes = (state) => {
    var localisedNotes = [...localisedCustomerNote];
    // localisedNotes[0].text = JSON.stringify(
    //   convertToRaw(state.getCurrentContent()),
    // );
    localisedNotes[0].text = state;
    setError({
      ...error,
      notesError: "",
    });
    // setNotesState(state);
    setCustomerNote(state);
    // setCustomerNote(JSON.stringify(convertToRaw(state.getCurrentContent())));
    setLocalisedCustomerNote(localisedNotes);
  };

  const [sectorData, setScetorData] = useState({
    sector: "",
    role: "",
  });
  const setRoleAndSector = (e) => {
    var data = { ...sectorData };
    data[e.target.name] = e.target.value;
    setScetorData(data);
  };

  const clearUserName = () => {
    setDetails({
      ...details,
      createdByUser: ""
    });
  }

  const [showUsernameDialog, setShowUsernameDialog] = useState(false);

  // open dialog then fetch page 0
  const openSearchUsernameDialog = () => {
    setShowUsernameDialog(true);
    // setPage(1);
    // searchUsers();
  };

  const onCloseUsernameDialog = () => {
    setShowUsernameDialog(false);
    // setUserFilters({ firstName: "", lastName: "", userId: "", emailAddress: "" });
    // setUserSearchResults([]);
    // setPage(1);
    // setRowsPerPage(10);
    // setTotalUsersCount(0);
  };

  const selectUser = (user) => () => {
    setDetails({
      ...details,
      createdByUser: user.userId
    });
    onCloseUsernameDialog();
  }

  return (
    <React.Fragment>
      {props.manageCustomer ? null : <Breadcrumb list={bread} />}
      {/* <h2 className={classes.checkoutTitle}> {`${!props.oldOrder ? `Checkout` : `Update`}: Business Account #${details.ban}`}</h2> */}
      {err ? err : null}
      {/* {props.loggedInUserType != "ECOMMERCE_CUSTOMER" &&
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6} >
                        {!props.oldOrder ?
                            <>
                                {newBan ?
                                    <Input inputClass={classes.inputClass}
                                        name={'ban'}
                                        size={'small'}
                                        variant={'outlined'}
                                        placeholder={props.t('CUSTOMER_BAN')}
                                        label={props.t('CUSTOMER_BAN') + ' *'}
                                        value={details.ban}
                                        onChange={(e) => {
                                            validateBanNo(e)
                                        }}
                                        onBlur={() => { validateBanOnBlur() }}
                                    />
                                    :
                                    props.loggedInUserType != "ECOMMERCE_CUSTOMER" &&
                                    <BanSelect onSelect={onSelect} selected={selected} addBan={setNewBan} customers={customers} disabled={props.selectedPromoBan !== '' && props.selectedPromoBan !== 'all'} />
                                }
                            </>
                            :
                            <Input inputClass={classes.inputClass}
                                name={'ban'}
                                size={'small'}
                                variant={'outlined'}
                                placeholder={props.t('CUSTOMER_BAN')}
                                label={props.t('CUSTOMER_BAN') + ' *'}
                                value={details.ban}
                                onChange={(e) => {
                                    validateBanNo(e)
                                }}
                                disabled={true}
                            />
                        }
                    </Grid>
                </Grid>
            } */}
      {!loading && (
        <>
          <StepperNew
            screen={"customer"}
            activeStep={activeStep}
            steps={steps}
            onStepSelect={changeStep}
          // back={goBackToTab}
          />
          <Box
            className="roundCorners"
            style={{
              border: "1px solid lightgrey",
              marginTop: "1rem",
              background: "white",
            }}
          >
            {activeStep === 0 && (
              <Grid container spacing={2} style={{ padding: "2rem" }}>
                {props.screenType !== "leads" && (
                  <>
                    <Grid
                      item
                      size={{
                        xs: 12,
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Switch
                            checked={details.custCodeAvailable}
                            onChange={handleSwitchChange}
                            name="custCodeAvailable"
                          />
                        }
                        label={props.t("CUST_CODE_AVAILABLE")}
                      />
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <Input
                        inputClass={classes.inputClass}
                        error={!!error.ban || invalidBan}
                        helperText={error.ban || invalidBan}
                        name={"ban"}
                        size={"small"}
                        variant={"outlined"}
                        placeholder={
                          details.custCodeAvailable
                            ? props.t("ACCOUNT_NUMBER") + " *"
                            : props.t("ACCOUNT_NUMBER")
                        }
                        value={details.ban}
                        onChange={(e) => {
                          validateBanNo(e);
                          setError({
                            ...error,
                            ban: "",
                          });
                          setInvalidBan(false);
                        }}
                        onBlur={handleBanBlur}
                        disabled={!details.custCodeAvailable}
                      />
                    </Grid>
                  </>
                )}
                {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                  props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: props.screenType === "leads" ? 3 : 6,
                      }}
                    >
                      <Input
                        inputClass={classes.inputClass}
                        error={!!error.accountName}
                        helperText={error.accountName}
                        size={"small"}
                        variant={"outlined"}
                        name={"accountName"}
                        // style={{ marginTop: '10px' }}
                        placeholder={props.t("ACCOUNT_NAME") + " *"}
                        value={details.accountName}
                        onChange={(e) => {
                          setDetails({
                            ...details,
                            [e.target.name]: e.target.value,
                          });
                          setError({
                            ...error,
                            accountName: "",
                          });
                          closeErrorMessage();
                        }}
                        onBlur={() => {
                          setDetails({
                            ...details,
                            accountName: details.accountName.trim(),
                          });
                        }}
                      />
                    </Grid>
                  )}
                {props.screenType && props.screenType === "leads" && (
                  <Grid
                    item
                    size={{
                      xs: 6,
                      md: 3,
                    }}
                  >
                    <FormControl
                      className="custom-select-input"
                      size={"small"}
                      variant={"outlined"}
                    >
                      <InputLabel htmlFor="outlined-age-native-simple">
                        {props.t("SECTOR") + " *"}
                      </InputLabel>
                      <Select
                        native
                        label="SECTOR"
                        value={sectorData.sector}
                        onChange={(e) => {
                          setRoleAndSector(e);
                          closeErrorMessage();
                        }}
                        inputProps={{
                          name: "sector",
                          id: "outlined-age-native-simple",
                        }}
                        selectClass={classes.inputClass}
                      // style={{ width: "180px" }}
                      >
                        <option value="" disabled>
                          {props.t("SECTOR") + " *"}
                        </option>
                        {sectorsList.map((sector, index) => (
                          <option key={index} value={sector.id}>
                            {sector.name}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
                {isManagedRequired &&
                  modules.length > 0 &&
                  modules.module_inventory === "enabled" && (
                    <>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 6,
                        }}
                      >
                        <FormControlLabel
                          style={{ marginLeft: "auto", marginRight: "auto" }}
                          control={
                            <Checkbox
                              checked={details.isManaged}
                              onChange={() => toggleManaged(!details.isManaged)}
                              onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                  toggleManaged(!details.isManaged);
                                }
                              }}
                            />
                          }
                        // label={t('IS_ACCOUNT_MANAGED')}
                        />
                        <span
                          style={{
                            position: "relative",
                            marginLeft: "5px",
                            fontSize: "14px",
                          }}
                        >
                          {t("IS_ACCOUNT_MANAGED")}
                        </span>
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 6,
                        }}
                      >
                        <Input
                          inputClass={classes.inputClass}
                          error={!!error.facilityNamePrefix}
                          helperText={error.facilityNamePrefix}
                          size={"small"}
                          variant={"outlined"}
                          name={"facilityNamePrefix"}
                          disabled={props.edit || !details.isManaged}
                          // style={{ marginTop: '10px' }}
                          placeholder={props.t("FACILITY_NAME_PREFIX") + " *"}
                          value={details.facilityNamePrefix}
                          onChange={(e) => {
                            setDetails({
                              ...details,
                              [e.target.name]: e.target.value,
                            });
                            setError({
                              ...error,
                              facilityNamePrefix: "",
                            });
                            closeErrorMessage();
                          }}
                        />
                      </Grid>
                    </>
                  )}
              </Grid>
            )}
            {details.ban ||
              newBan ||
              props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
              props.loggedInUserType === "ECOMMERCE_ADMIN" ? (
              <React.Fragment>
                {/* {props.loggedInUserType !== "ECOMMERCE_CUSTOMER" && <Grid container spacing={3}>
                        <Grid item xs={12} md={6} >
                            <Input inputClass={classes.inputClass}
                                size={'small'}
                                variant={'outlined'}
                                name={'accountName'}
                                style={{ marginTop: '10px' }}
                                placeholder={props.t('ACCOUNT_NAME') + ' *'}
                                value={details.accountName}
                                onChange={(e) => {
                                    setDetails({ ...details, [e.target.name]: e.target.value });
                                    closeErrorMessage()
                                }}
                            />
                        </Grid>
                    </Grid>} */}
                {(props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                  props.loggedInUserType !== "ECOMMERCE_ADMIN") &&
                  activeStep === 1 && (
                    <>
                      <Grid container spacing={2} style={{ padding: "2rem" }}>
                        <Grid
                          item
                          size={{
                            xs: 12,
                          }}
                        >
                          {/* <h3 className={classes.DetailssubTitle + ' ' + classes.headinBottomMargin}>{t('CONTACT_DETAILS')}</h3> */}
                          <h3 style={{ margin: 0 }}>{t("CONTACT_DETAILS")}</h3>
                        </Grid>
                        {/* <Divider style={{ borderBottom: '1px solid'}} /> */}

                        <Grid
                          item
                          size={{
                            xs: 12,
                            md: 6,
                          }}
                        >
                          <Input
                            error={!!error.firstName}
                            helperText={error.firstName}
                            inputClass={classes.inputClass}
                            size={"small"}
                            name={"firstName"}
                            variant={"outlined"}
                            style={{ marginTop: "15px" }}
                            placeholder={props.t("FIRST_NAME")}
                            value={details.firstName}
                            onChange={(e) => {
                              setDetails({
                                ...details,
                                [e.target.name]: e.target.value,
                              });
                              setError({
                                ...error,
                                firstName: "",
                              });
                              closeErrorMessage();
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          size={{
                            xs: 12,
                            md: 6,
                          }}
                        >
                          <Input
                            inputClass={classes.inputClass}
                            error={!!error.lastName}
                            helperText={error.lastName}
                            name={"lastName"}
                            size={"small"}
                            variant={"outlined"}
                            placeholder={props.t("LAST_NAME")}
                            value={details.lastName}
                            style={{ marginTop: "15px" }}
                            onChange={(e) => {
                              setDetails({
                                ...details,
                                [e.target.name]: e.target.value,
                              });
                              setError({
                                ...error,
                                lastName: "",
                              });
                              closeErrorMessage();
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          size={{
                            xs: 12,
                            md: 6,
                          }}
                        >
                          <InputPhone
                            inputClass={classes.inputClass}
                            error={!!error.officePhone}
                            helperText={error.officePhone}
                            size={"small"}
                            variant={"outlined"}
                            name={"officePhone"}
                            placeholder={props.t("OFFICE_PHONE")}
                            value={details.officePhone}
                            onChange={(e) => {
                              setDetails({
                                ...details,
                                [e.target.name]: e.target.value,
                              });
                              setError({
                                ...error,
                                officePhone: "",
                              });
                              closeErrorMessage();
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          size={{
                            xs: 12,
                            md: 6,
                          }}
                        >
                          <InputPhone
                            inputClass={classes.inputClass}
                            error={!!error.mobilePhone}
                            helperText={error.mobilePhone}
                            size={"small"}
                            variant={"outlined"}
                            name={"mobilePhone"}
                            placeholder={props.t("MOBILE_PHONE")}
                            value={details.mobilePhone}
                            onChange={(e) => {
                              setDetails({
                                ...details,
                                [e.target.name]: e.target.value,
                              });
                              setError({
                                ...error,
                                mobilePhone: "",
                              });
                              closeErrorMessage();
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          size={{
                            xs: 12,
                            md: 6,
                          }}
                        >
                          <Input
                            inputClass={classes.inputClass}
                            error={!!error.email}
                            helperText={error.email}
                            name={"email"}
                            size={"small"}
                            variant={"outlined"}
                            placeholder={props.t("EMAIL") + " *"}
                            value={details.email}
                            onChange={(e) => {
                              setDetails({
                                ...details,
                                [e.target.name]: e.target.value,
                              });
                              setError({
                                ...error,
                                email: "",
                              });
                              closeErrorMessage();
                            }}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}
                {/* Payment method */}
                {activeStep === 2 && (
                  <Grid container spacing={2} style={{ padding: "2rem" }}>
                    <Grid
                      item
                      size={{
                        xs: 12,
                      }}
                    >
                      {/* <h3 className={classes.DetailssubTitle + ' ' + classes.headinBottomMarginLabel}>{props.t('BILLING_CYCLE_DAY')}</h3> */}
                      <h3 style={{ margin: 0 }}>
                        {props.t("BILLING_CYCLE_DAY")}
                      </h3>
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      {/* <Select
                                onChange={(e) => {
                                    setDetails({ ...details, [e.target.name]: e.target.value });
                                    closeErrorMessage()
                                }}
                                selectClass={classes.inputClass}
                                name={'billingCloseDay'}
                                //label={props.t('BILLING_CYCLE_DAY') + ' *'}
                                selected={details.billingCloseDay}
                                options={daysArray()}
                                default={1}
                                value={(a) => a}
                                optionLabel={(a) => a}
                                disabled={disableBillingDay}
                            /> */}

                      <FormControl
                        className="custom-select-input"
                        size={"small"}
                        variant={"outlined"}
                      >
                        <InputLabel htmlFor="outlined-age-native-simple">
                          {props.t("BILLING_CYCLE_DAY") + " *"}
                        </InputLabel>
                        <Select
                          native
                          label="BILLING_CYCLE_DAY"
                          value={details.billingCloseDay}
                          onChange={(e) => {
                            setDetails({
                              ...details,
                              [e.target.name]: e.target.value,
                            });
                            closeErrorMessage();
                          }}
                          inputProps={{
                            name: "billingCloseDay",
                            id: "outlined-age-native-simple",
                          }}
                          disabled={disableBillingDay}
                          selectClass={classes.inputClass}
                          style={{ width: "180px" }}
                        >
                          <option value="" disabled>
                            {props.t("BILLING_CYCLE_DAY") + " *"}
                          </option>
                          {daysArray().map((day) => (
                            <option key={day} value={day}>
                              {day}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                )}
                {activeStep === 2 && (
                  <Grid container spacing={2} style={{ padding: "2rem" }}>
                    {/* <Grid item xs={12}>
                            <h3 className={classes.DetailssubTitle + ' ' + classes.headinBottomMarginLabel}>{props.t('PAYMENT_METHOD')}
                            <h3>{props.t('PAYMENT_METHOD')}
                                <Link className={classes.chooseExistingDialog} style={{ color: props.tenantData.color, marginLeft: '13px' }} onClick={() => { chooseCustomerDetails("payment") }}>Choose different Payment</Link>
                            </h3>
                        </Grid> */}
                    {/* <Divider style={{ borderBottom: '1px solid', width: '100%' }} /> */}
                    <Grid
                      item
                      size={{
                        xs: 12,
                      }}
                    >
                      <FormControlLabel
                        style={{ marginLeft: "auto", marginRight: "auto" }}
                        control={
                          <Checkbox
                            checked={addPayment}
                            onChange={() => addPaymentToggle(!addPayment)}
                            onKeyDown={(event) => {
                              if (event.key === "Enter") {
                                addPaymentToggle(!addPayment);
                              }
                            }}
                          />
                        }
                      />
                      <span
                        style={{
                          position: "relative",
                          marginLeft: "5px",
                          fontSize: "14px",
                        }}
                      >
                        {t("ADD_PAYMENT_METHOD")}
                      </span>
                    </Grid>
                    {addPayment && (
                      <>
                        <Grid
                          item
                          size={{
                            xs: 12,
                            md: 6,
                          }}
                        >
                          <FormControl
                            variant="outlined"
                            className="custom-select-input"
                            size={"small"}
                            error={!!error.selectPaymentMethod}
                          >
                            <InputLabel htmlFor="outlined-native-payment">
                              {props.t("SELECT_A_PAYMENT_METHOD") + " *"}
                            </InputLabel>
                            <Select
                              native
                              label="SELECT_A_PAYMENT_METHOD"
                              variant={"outlined"}
                              name={"payment"}
                              inputProps={{
                                id: "outlined-native-payment",
                              }}
                              //placeholder={'Add New Payment Method'}
                              //label={props.t('Add New Payment Method')}
                              onChange={(e) => {
                                addPaymentMethod(e);
                                setError({
                                  ...error,
                                  selectPaymentMethod: "",
                                });
                              }}
                            //selectClass={classes.inputClass}
                            //selected={selectedPaymentOption}
                            //options={paymentOptions}
                            //value={(a) => a.value}
                            //optionLabel={(a) => a.name}
                            >
                              {/* <option value="" disabled>{props.t('Add Payment Method') + ' *'}</option> */}
                              <option value="" disabled selected></option>
                              {paymentOptions.map((a) => (
                                <option key={a.value} value={a.value}>
                                  {a.name}
                                </option>
                              ))}
                            </Select>
                            {error.selectPaymentMethod && (
                              <span
                                style={{
                                  color: "#f44336",
                                  marginLeft: "0px",
                                  fontSize: "0.75rem",
                                  marginTop: "4px",
                                }}
                              >
                                {error.selectPaymentMethod}
                              </span>
                            )}
                          </FormControl>
                        </Grid>

                        {/* Add credit card section start */}
                        {selectedPaymentOption === "creditCard" && (
                          <Grid
                            item
                            size={{
                              xs: 6,
                            }}
                          >
                            <Grid
                              container
                              spacing={2}
                              style={{ padding: "2rem" }}
                            >
                              {/* <Grid item xs={2}>
                                                                <CardPaymentIcon id={cardData.cardLogoId} style={{ width: 70, height: 40 }} className="payment-icon" />
                                                            </Grid>
                                                            <Grid item xs={10}>
                                                                <Input
                                                                    error={!!error.cardNumber}
                                                                    helperText={error.cardNumber}
                                                                    size={"small"}
                                                                    variant={"outlined"}
                                                                    name={"cardNumber"}
                                                                    placeholder={props.t("CARD_NUMBER") + " *"}
                                                                    value={cardData.cardNumber}
                                                                    onChange={(event) => {
                                                                        onChangeForm(event);
                                                                        setError({
                                                                            ...error,
                                                                            cardNumber: "",
                                                                        });
                                                                    }}
                                                                />
                                                            </Grid> */}
                              <Grid
                                item
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                size={{
                                  xs: 12,
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    position: "relative",
                                  }}
                                >
                                  <Input
                                    error={!!error.cardNumber}
                                    helperText={error.cardNumber}
                                    size={"small"}
                                    variant={"outlined"}
                                    name={"cardNumber"}
                                    placeholder={props.t("CARD_NUMBER") + " *"}
                                    value={cardData.cardNumber}
                                    onChange={(event) => {
                                      onChangeForm(event);
                                      setError({
                                        ...error,
                                        cardNumber: "",
                                      });
                                    }}
                                    style={{ width: "100%" }}
                                  />
                                  {cardData.cardLogoId && (
                                    <CardPaymentIcon
                                      id={cardData.cardLogoId}
                                      style={{
                                        height: 24,
                                        position: "absolute",
                                        right: 12,
                                        pointerEvents: "none",
                                      }}
                                      className="payment-icon"
                                    />
                                  )}
                                </div>
                              </Grid>
                              <Grid
                                item
                                size={{
                                  xs: 6,
                                }}
                              >
                                <Input
                                  error={!!error.firstNameOnCard}
                                  helperText={error.firstNameOnCard}
                                  size={"small"}
                                  variant={"outlined"}
                                  name={"firstNameOnCard"}
                                  placeholder={
                                    props.t("FIRST_NAME_ON_CARD") + " *"
                                  }
                                  value={cardData.firstNameOnCard}
                                  onChange={(event) => {
                                    onChangeForm(event);
                                    setError({
                                      ...error,
                                      firstNameOnCard: "",
                                    });
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                size={{
                                  xs: 6,
                                }}
                              >
                                <Input
                                  error={!!error.lastNameOnCard}
                                  helperText={error.lastNameOnCard}
                                  size={"small"}
                                  variant={"outlined"}
                                  name={"lastNameOnCard"}
                                  placeholder={
                                    props.t("LAST_NAME_ON_CARD") + " *"
                                  }
                                  value={cardData.lastNameOnCard}
                                  onChange={(event) => {
                                    onChangeForm(event);
                                    setError({
                                      ...error,
                                      lastNameOnCard: "",
                                    });
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                size={{
                                  xs: 6,
                                }}
                              >
                                {/* <FormControl className="custom-select-input" size={"small"} error={!!error.expireMonth}>
                                                                    <Select
                                                                        native
                                                                        label='Expire Month'
                                                                        size={"small"}
                                                                        variant={"outlined"}
                                                                        onChange={(event) => {
                                                                            onChangeForm(event);
                                                                            setError({
                                                                                ...error,
                                                                                expireMonth: "",
                                                                            });
                                                                        }}
                                                                        value={cardData.expireMonth}
                                                                        placeholder={props.t("EXPIRY_MONTH") + " *"}
                                                                        inputProps={{
                                                                            name: "expireMonth",
                                                                            id: "expireMonth",
                                                                        }}
                                                                    >
                                                                        <option value="" disabled>
                                                                            {props.t("EXPIRY_MONTH") + " *"}
                                                                        </option>
                                                                        {months.map((opt) => (
                                                                            <option key={opt} value={opt}>
                                                                                {opt}
                                                                            </option>
                                                                        ))}
                                                                    </Select>
                                                                    {error.expireMonth && (
                                                                        <span style={{ color: "#f44336", marginLeft: "0px", fontSize: "0.75rem", marginTop: "4px" }}>
                                                                            {error.expireMonth}
                                                                        </span>
                                                                    )}
                                                                </FormControl> */}
                                <FormControl
                                  variant="outlined"
                                  className="custom-select-input"
                                  size={"small"}
                                >
                                  <InputLabel htmlFor="expireMonth">
                                    {t("EXPIRY_MONTH") + " *"}
                                  </InputLabel>
                                  <Select
                                    native
                                    label={t("EXPIRY_MONTH") + " *"}
                                    onChange={(event) => {
                                      onChangeForm(event);
                                      setError({
                                        ...error,
                                        expireMonth: "",
                                      });
                                    }}
                                    value={cardData.expireMonth}
                                    inputProps={{
                                      name: "expireMonth",
                                      id: "expireMonth",
                                    }}
                                  >
                                    <option value="" disabled></option>
                                    {months.map((opt) => (
                                      <option key={opt} value={opt}>
                                        {opt}
                                      </option>
                                    ))}
                                  </Select>
                                  {error.expireMonth && (
                                    <span
                                      style={{
                                        color: "#f44336",
                                        marginLeft: "0px",
                                        fontSize: "0.75rem",
                                        marginTop: "4px",
                                      }}
                                    >
                                      {error.expireMonth}
                                    </span>
                                  )}
                                </FormControl>
                              </Grid>
                              <Grid
                                item
                                size={{
                                  xs: 6,
                                }}
                              >
                                {/* <FormControl className="custom-select-input" size={"small"} error={!!error.expireYear}>
                                                                    <Select
                                                                        native
                                                                        label='Expire Year'
                                                                        size={"small"}
                                                                        variant={"outlined"}
                                                                        onChange={(event) => {
                                                                            onChangeForm(event);
                                                                            setError({
                                                                                ...error,
                                                                                expireYear: "",
                                                                            });
                                                                        }}
                                                                        value={cardData.expireYear}
                                                                        placeholder={props.t("EXPIRY_YEAR") + " *"}
                                                                        inputProps={{
                                                                            name: "expireYear",
                                                                            id: "expireYear",
                                                                        }}
                                                                    >
                                                                        <option value="" disabled selected>
                                                                            {props.t("EXPIRY_YEAR") + " *"}
                                                                        </option>
                                                                        {years.map((opt) => (
                                                                            <option key={opt} value={opt}>
                                                                                {opt}
                                                                            </option>
                                                                        ))}
                                                                    </Select>
                                                                    {error.expireYear && (
                                                                        <span style={{ color: "#f44336", marginLeft: "0px", fontSize: "0.75rem", marginTop: "4px" }}>
                                                                            {error.expireYear}
                                                                        </span>
                                                                    )}
                                                                </FormControl> */}
                                <FormControl
                                  variant="outlined"
                                  className="custom-select-input"
                                  size={"small"}
                                >
                                  <InputLabel htmlFor="expireYear">
                                    {props.t("EXPIRY_YEAR") + " *"}
                                  </InputLabel>
                                  <Select
                                    native
                                    label={props.t("EXPIRY_YEAR") + " *"}
                                    onChange={(event) => {
                                      onChangeForm(event);
                                      setError({
                                        ...error,
                                        expireYear: "",
                                      });
                                    }}
                                    value={cardData.expireYear}
                                    inputProps={{
                                      name: "expireYear",
                                      id: "expireYear",
                                    }}
                                  >
                                    <option value="" disabled selected></option>
                                    {years.map((opt) => (
                                      <option key={opt} value={opt}>
                                        {opt}
                                      </option>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        {selectedPaymentOption === "bankAccount" && (
                          <>
                            <Grid
                              container
                              spacing={2}
                              style={{ padding: "2rem" }}
                            >
                              <Grid
                                item
                                size={{
                                  xs: 6,
                                  md: 6,
                                }}
                              >
                                <Input
                                  error={!!error.bankName}
                                  helperText={error.bankName}
                                  size={"small"}
                                  variant={"outlined"}
                                  name={"bankName"}
                                  placeholder={t("BANK_NAME") + " *"}
                                  value={bankAccount.bankName}
                                  onChange={(event) => {
                                    changeBankAccount(event);
                                    setError({
                                      ...error,
                                      bankName: "",
                                    });
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                size={{
                                  xs: 6,
                                  md: 6,
                                }}
                              >
                                <Input
                                  error={!!error.nameOnAccount}
                                  helperText={error.nameOnAccount}
                                  size={"small"}
                                  variant={"outlined"}
                                  name={"nameOnAccount"}
                                  placeholder={t("NAME_ON_ACCOUNT") + " *"}
                                  value={bankAccount.nameOnAccount}
                                  onChange={(event) => {
                                    changeBankAccount(event);
                                    setError({
                                      ...error,
                                      nameOnAccount: "",
                                    });
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                size={{
                                  xs: 6,
                                  md: 6,
                                }}
                              >
                                <Input
                                  error={!!error.routingNumber}
                                  helperText={error.routingNumber}
                                  size={"small"}
                                  variant={"outlined"}
                                  name={"routingNumber"}
                                  placeholder={
                                    t("ROUTING_NUMBER_9_DIGIT") + " *"
                                  }
                                  value={bankAccount.routingNumber}
                                  onChange={(event) => {
                                    changeBankAccount(event);
                                    setError({
                                      ...error,
                                      routingNumber: "",
                                    });
                                  }}
                                />
                              </Grid>
                              <Grid
                                item
                                size={{
                                  xs: 6,
                                  md: 6,
                                }}
                              >
                                <Input
                                  error={!!error.accountNumber}
                                  helperText={error.accountNumber}
                                  size={"small"}
                                  variant={"outlined"}
                                  name={"accountNumber"}
                                  placeholder={
                                    t("ACCOUNT_NUMBER_UP_TO_17_DIGITS") + " *"
                                  }
                                  value={bankAccount.accountNumber}
                                  onChange={(event) => {
                                    changeBankAccount(event);
                                    setError({
                                      ...error,
                                      accountNumber: "",
                                    });
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </>
                        )}
                      </>
                    )}
                  </Grid>
                )}
                {/* Add credit card section end */}

                {/* {details.paymentMethod.creditCards && details.paymentMethod.creditCards.length > 0 &&
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Name on Card</TableCell>
                                            <TableCell>Card Number</TableCell>
                                            <TableCell>Expiry Date</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>{details.paymentMethod.creditCards[0].firstNameOnCard} {details.paymentMethod.creditCards[0].lastNameOnCard}</TableCell>
                                            <TableCell>{details.paymentMethod.creditCards[0].cardNumber}</TableCell>
                                            <TableCell>{details.paymentMethod.creditCards[0].expireDate}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Grid>
                        </Grid>
                    }
                    {details.paymentMethod.eftAccount && details.paymentMethod.eftAccount.length > 0 &&
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Bank Name</TableCell>
                                            <TableCell>Account Number</TableCell>
                                            <TableCell>Routing Number</TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {details.paymentMethod.eftAccount.map((eft, i) =>
                                            <TableRow key={i}>
                                                <TableCell>{eft.bankName}</TableCell>
                                                <TableCell>{eft.accountNumber}</TableCell>
                                                <TableCell>{eft.routingNumber}</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </Grid>
                        </Grid>
                    } */}

                {activeStep === 0 && <Divider variant="middle" />}

                {activeStep === 0 &&
                  props.screenType &&
                  props.screenType === "leads" && (
                    // <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <>
                      <Grid container spacing={2} style={{ padding: "2rem" }}>
                        <Grid
                          item
                          style={{ marginBottom: ".2rem" }}
                          size={{
                            xs: 12,
                          }}
                        >
                          <h3 style={{ margin: 0 }}>
                            {props.t("OPPORTUNITY_DESCRIPTION")}
                          </h3>
                        </Grid>
                        <Grid
                          item
                          className={
                            error.notesError && error.notesError !== ""
                              ? "rich_text_error"
                              : ""
                          }
                          size={{
                            xs: 12,
                            md: 6,
                          }}
                        >
                          <TiptapEditor
                            value={customerNote}
                            onChange={onChangeNotes}
                            placeholder={
                              props.t("OPPORTUNITY_DESCRIPTION") + " *"
                            }
                          />
                          {error.notesError && error.notesError !== "" && (
                            <label
                              style={{
                                fontSize: "0.75rem",
                                color: "#f44336",
                                marginTop: "4px",
                                display: "block",
                              }}
                            >
                              {error.notesError}
                            </label>
                          )}
                        </Grid>
                      </Grid>
                    </>
                    // </div>
                  )}
                {activeStep === 0 && <Divider variant="middle" />}
                {/* <Grid container spacing={1}>
                        <label style={{ marginTop: '50px', color: '#f44336' }}>{props.t('BILLING_AND_SHIPPING_ADDRESSES_NOTE')}</label>
                    </Grid> */}
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  {activeStep === 0 &&
                    modules &&
                    modules.module_customer_billing === "enabled" && (
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 6,
                        }}
                      >
                        <Grid container spacing={2} style={{ padding: "2rem" }}>
                          <Grid
                            item
                            style={{ marginBottom: ".2rem" }}
                            size={{
                              xs: 12,
                            }}
                          >
                            {/* <h3 className={classes.DetailssubTitle + ' ' + classes.headinBottomMargin}>{props.t('BILLING_ADDRESS')}</h3> */}
                            <h3 style={{ margin: 0 }}>
                              {props.t("BILLING_ADDRESS")}
                            </h3>
                          </Grid>
                          {/* <Link onClick={() => { chooseCustomerDetails("billing") }} style={{ cursor: 'pointer', paddingTop: '18px' }}>Choose different address</Link> */}
                          {/* <Divider style={{ borderBottom: '1px solid', width: '100%' }} /> */}
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            <Input
                              inputClass={classes.inputClass}
                              error={!!error.attention}
                              helperText={error.attention}
                              size={"small"}
                              variant={"outlined"}
                              name={"attention"}
                              // style={{ marginTop: '15px' }}
                              placeholder={props.t("ATTENTION") + " *"}
                              value={details.billing.attention}
                              onChange={(e) => {
                                setBilling(e);
                                setError({
                                  ...error,
                                  attention: "",
                                });
                              }}
                            />
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            <InputPhone
                              inputClass={classes.inputClass}
                              error={!!error.phone}
                              helperText={error.phone}
                              name={"phone"}
                              size={"small"}
                              variant={"outlined"}
                              // style={{ marginTop: '15px' }}
                              placeholder={props.t("PHONE")}
                              value={details.billing.phone}
                              onChange={(e) => {
                                setBilling(e);
                                setError({
                                  ...error,
                                  phone: "",
                                });
                              }}
                            />
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            <Input
                              inputClass={classes.inputClass}
                              error={!!error.street1}
                              helperText={error.street1}
                              name={"street1"}
                              size={"small"}
                              variant={"outlined"}
                              placeholder={props.t("STREET1") + " *"}
                              value={details.billing.street1}
                              onChange={(e) => {
                                setBilling(e);
                                setError({
                                  ...error,
                                  street1: "",
                                });
                              }}
                            />
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            <Input
                              inputClass={classes.inputClass}
                              name={"street2"}
                              size={"small"}
                              variant={"outlined"}
                              placeholder={props.t("STREET2")}
                              value={details.billing.street2}
                              onChange={(e) => {
                                setBilling(e);
                              }}
                            />
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            <Input
                              inputClass={classes.inputClass}
                              error={!!error.city}
                              helperText={error.city}
                              name={"city"}
                              size={"small"}
                              variant={"outlined"}
                              placeholder={props.t("CITY") + " *"}
                              value={details.billing.city}
                              onChange={(e) => {
                                setBilling(e);
                                setError({
                                  ...error,
                                  city: "",
                                });
                              }}
                            />
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            <Input
                              inputClass={classes.inputClass}
                              error={!!error.zip}
                              helperText={error.zip}
                              name={"zip"}
                              size={"small"}
                              variant={"outlined"}
                              placeholder={props.t("ZIP")}
                              value={details.billing.zip}
                              onChange={(e) => {
                                setBilling(e);
                                setError({
                                  ...error,
                                  zip: "",
                                });
                              }}
                            />
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            {/* <Select
                                onChange={(e) => {
                                    setBilling(e)
                                }}
                                selectClass={classes.inputClass}
                                name={'country'}
                                label={props.t('COUNTRY') + ' *'}
                                selected={details.billing.country}
                                options={stateCode.country}
                                default={props.t('SELECT_COUNTRY')}
                                value={(a) => a.abbreviation}
                                optionLabel={(a) => a.name}
                            /> */}
                            <FormControl
                              variant="outlined"
                              className="custom-select-input"
                              size={"small"}
                            >
                              <InputLabel
                                id="outlined-age-native-country"
                                htmlFor="outlined-age-native-country"
                              >
                                {" "}
                                {props.t("COUNTRY") + " *"}
                              </InputLabel>
                              <Select
                                native
                                label="country"
                                labelId="outlined-age-native-country"
                                value={details.billing.country}
                                onChange={(e) => {
                                  // setBilling(e);
                                  setStateListChange(e.target.value, "billing");
                                }}
                                inputProps={{
                                  name: "country",
                                  id: "outlined-age-native-country",
                                }}
                              >
                                {countriesList.map((a) => (
                                  <option key={a.id} value={a.id}>
                                    {a.name}
                                  </option>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            {/* <Select
                                name={'state'}
                                placeholder={props.t('STATE')}
                                label={props.t('STATE') + ' *'}
                                onChange={(e) => {
                                    setBilling(e)
                                }}
                                selectClass={classes.inputClass}
                                selected={details.billing.state}
                                options={details.billing && details.billing.country ? stateCode.state[details.billing.country] : []}
                                default={props.t('SELECT_STATE')}
                                value={(a) => a.abbreviation}
                                optionLabel={(a) => a.name}
                            /> */}

                            <FormControl
                              variant="outlined"
                              className="custom-select-input"
                              size={"small"}
                            >
                              <InputLabel
                                id="outlined-age-native-state"
                                htmlFor="outlined-age-native-state"
                              >
                                {props.t("STATE") + " *"}
                              </InputLabel>
                              <Select
                                native
                                label="state"
                                labelId="outlined-age-native-state"
                                error={!!error.state}
                                value={details.billing.state}
                                onChange={(e) => {
                                  setBilling(e);
                                  setError({
                                    ...error,
                                    state: "",
                                  });
                                }}
                                inputProps={{
                                  name: "state",
                                  id: "outlined-age-native-state",
                                }}
                              >
                                {billingStateList.map((a) => (
                                  <option key={a.id} value={a.id}>
                                    {a.name}
                                  </option>
                                ))}
                                {/* {(details.billing && details.billing.country) &&
                                        stateCode.state[details.billing.country]
                                            .map(a => (
                                                <option key={a.abbreviation} value={a.abbreviation}>{a.name}</option>
                                            ))} */}
                              </Select>
                              {error.state && (
                                <span
                                  style={{
                                    color: "#f44336",
                                    marginLeft: "0px",
                                    fontSize: "0.75rem",
                                    marginTop: "4px",
                                  }}
                                >
                                  {error.state}
                                </span>
                              )}
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}

                  {activeStep === 0 &&
                    props.screenType &&
                    props.screenType === "leads" && (
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 6,
                        }}
                      >
                        <Grid
                          container
                          spacing={2}
                          style={{ padding: "2rem", paddingRight: "10px" }}
                        >
                          <Grid
                            item
                            size={{
                              xs: 12,
                            }}
                          >
                            {/* <h3 className={classes.DetailssubTitle + ' ' + classes.headinBottomMarginLabel}>{props.t('SHIPPING_ADDRESS')}</h3> */}
                            <h3 style={{ margin: 0 }}>
                              {props.t("LEAD_CONTACT_&_ROLE")}
                            </h3>
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            <Input
                              error={!!error.firstName}
                              helperText={error.firstName}
                              inputClass={classes.inputClass}
                              size={"small"}
                              name={"firstName"}
                              variant={"outlined"}
                              style={{ marginTop: "15px" }}
                              placeholder={props.t("FIRST_NAME") + " *"}
                              value={details.firstName}
                              onChange={(e) => {
                                setDetails({
                                  ...details,
                                  [e.target.name]: e.target.value,
                                });
                                setError({
                                  ...error,
                                  firstName: "",
                                });
                                closeErrorMessage();
                              }}
                            />
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            <Input
                              inputClass={classes.inputClass}
                              error={!!error.lastName}
                              helperText={error.lastName}
                              name={"lastName"}
                              size={"small"}
                              variant={"outlined"}
                              placeholder={props.t("LAST_NAME") + " *"}
                              value={details.lastName}
                              style={{ marginTop: "15px" }}
                              onChange={(e) => {
                                setDetails({
                                  ...details,
                                  [e.target.name]: e.target.value,
                                });
                                setError({
                                  ...error,
                                  lastName: "",
                                });
                                closeErrorMessage();
                              }}
                            />
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            <InputPhone
                              inputClass={classes.inputClass}
                              error={!!error.mobilePhone}
                              helperText={error.mobilePhone}
                              size={"small"}
                              variant={"outlined"}
                              name={"mobilePhone"}
                              placeholder={props.t("MOBILE_PHONE") + " *"}
                              value={details.mobilePhone}
                              onChange={(e) => {
                                setDetails({
                                  ...details,
                                  [e.target.name]: e.target.value,
                                });
                                setError({
                                  ...error,
                                  mobilePhone: "",
                                });
                                closeErrorMessage();
                              }}
                            />
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            <Input
                              inputClass={classes.inputClass}
                              error={!!error.email}
                              helperText={error.email}
                              name={"email"}
                              size={"small"}
                              variant={"outlined"}
                              placeholder={props.t("EMAIL") + " *"}
                              value={details.email}
                              onChange={(e) => {
                                setDetails({
                                  ...details,
                                  [e.target.name]: e.target.value,
                                });
                                setError({
                                  ...error,
                                  email: "",
                                });
                                closeErrorMessage();
                              }}
                            />
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            <Input
                              inputClass={classes.inputClass}
                              error={!!error.city_shipping}
                              helperText={error.city_shipping}
                              name={"city"}
                              size={"small"}
                              variant={"outlined"}
                              placeholder={props.t("CITY") + " *"}
                              value={details.shipping.city}
                              onChange={(e) => {
                                setShipping(e);
                                setError({
                                  ...error,
                                  city_shipping: "",
                                });
                              }}
                            />
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            <Input
                              error={!!error.role}
                              helperText={error.role}
                              inputClass={classes.inputClass}
                              size={"small"}
                              name={"role"}
                              variant={"outlined"}
                              placeholder={props.t("ROLE") + " *"}
                              value={sectorData.role}
                              onChange={(e) => {
                                setRoleAndSector(e);
                                setError({
                                  ...error,
                                  role: "",
                                });
                                closeErrorMessage();
                              }}
                              onBlur={async (e) => {
                                setRoleAndSector(e);
                                // await verifyUserId();
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    )}

                  {activeStep === 0 && props.screenType !== "leads" && (
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <Grid
                        container
                        spacing={2}
                        style={{ padding: "2rem", paddingRight: "10px" }}
                      >
                        <Grid
                          item
                          size={{
                            xs: 12,
                            md: 6,
                          }}
                        >
                          {/* <h3 className={classes.DetailssubTitle + ' ' + classes.headinBottomMarginLabel}>{props.t('SHIPPING_ADDRESS')}</h3> */}
                          <h3 style={{ margin: 0 }}>
                            {props.t("SHIPPING_ADDRESS")}
                          </h3>
                        </Grid>
                        {/* <Link onClick={() => { chooseCustomerDetails("shipping") }} style={{ cursor: 'pointer', paddingTop: '18px'}}>Choose different Address</Link> */}
                        {/* <Divider style={{ borderBottom: '1px solid', width: '100%' }} /> */}
                        <Grid
                          item
                          style={{ paddingBottom: "0px" }}
                          size={{
                            xs: 12,
                            md: 6,
                          }}
                        >
                          {modules &&
                            modules.module_customer_billing === "enabled" && (
                              <FormControlLabel
                                style={{ marginLeft: 0 }}
                                control={
                                  <Checkbox
                                    color="primary"
                                    checked={isSame}
                                    onChange={(e) => {
                                      setIsSame(!isSame);
                                    }}
                                    onKeyDown={(event) => {
                                      if (event.key === "Enter") {
                                        setIsSame(!isSame);
                                      }
                                    }}
                                    name="sameCheck"
                                  />
                                }
                                label={props.t("USE_SAME_AS_BILLING_ADDRESS")}
                              />
                            )}
                        </Grid>
                        {isSame ? null : (
                          <React.Fragment>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 6,
                              }}
                            >
                              <Input
                                inputClass={classes.inputClass}
                                error={!!error.attention_shipping}
                                helperText={error.attention_shipping}
                                size={"small"}
                                variant={"outlined"}
                                name={"attention"}
                                placeholder={
                                  props.screenType &&
                                    props.screenType === "leads"
                                    ? props.t("CONTACT_PERSON") + " *"
                                    : props.t("ATTENTION") + " *"
                                }
                                value={details.shipping.attention}
                                onChange={(e) => {
                                  setShipping(e);
                                  setError({
                                    ...error,
                                    attention_shipping: "",
                                  });
                                }}
                              />
                            </Grid>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 6,
                              }}
                            >
                              <InputPhone
                                inputClass={classes.inputClass}
                                error={!!error.phone_shipping}
                                helperText={error.phone_shipping}
                                name={"phone"}
                                size={"small"}
                                variant={"outlined"}
                                placeholder={props.t("PHONE")}
                                value={details.shipping.phone}
                                onChange={(e) => {
                                  setShipping(e);
                                  setError({
                                    ...error,
                                    phone_shipping: "",
                                  });
                                }}
                              />
                            </Grid>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 6,
                              }}
                            >
                              <Input
                                inputClass={classes.inputClass}
                                error={!!error.street1_shipping}
                                helperText={error.street1_shipping}
                                name={"street1"}
                                size={"small"}
                                variant={"outlined"}
                                placeholder={
                                  props.t("STREET1") +
                                  (props.screenType &&
                                    props.screenType === "leads"
                                    ? ""
                                    : " *")
                                }
                                value={details.shipping.street1}
                                onChange={(e) => {
                                  setShipping(e);
                                  setError({
                                    ...error,
                                    street1_shipping: "",
                                  });
                                }}
                              />
                            </Grid>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 6,
                              }}
                            >
                              <Input
                                inputClass={classes.inputClass}
                                name={"street2"}
                                size={"small"}
                                variant={"outlined"}
                                placeholder={props.t("STREET2")}
                                value={details.shipping.street2}
                                onChange={(e) => {
                                  setShipping(e);
                                }}
                              />
                            </Grid>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 6,
                              }}
                            >
                              <Input
                                inputClass={classes.inputClass}
                                error={!!error.city_shipping}
                                helperText={error.city_shipping}
                                name={"city"}
                                size={"small"}
                                variant={"outlined"}
                                placeholder={props.t("CITY") + " *"}
                                value={details.shipping.city}
                                onChange={(e) => {
                                  setShipping(e);
                                  setError({
                                    ...error,
                                    city_shipping: "",
                                  });
                                }}
                              />
                            </Grid>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 6,
                              }}
                            >
                              <Input
                                inputClass={classes.inputClass}
                                error={!!error.zip_shipping}
                                helperText={error.zip_shipping}
                                name={"zip"}
                                size={"small"}
                                variant={"outlined"}
                                placeholder={props.t("ZIP")}
                                value={details.shipping.zip}
                                onChange={(e) => {
                                  setShipping(e);
                                  setError({
                                    ...error,
                                    zip_shipping: "",
                                  });
                                }}
                              />
                            </Grid>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 6,
                              }}
                            >
                              {/* <Select
                                        onChange={(e) => {
                                            setShipping(e)
                                        }}
                                        selectClass={classes.inputClass}
                                        name={'country'}
                                        label={props.t('COUNTRY') + ' *'}
                                        selected={details.shipping.country}
                                        options={stateCode.country}
                                        default={props.t('SELECT_COUNTRY')}
                                        value={(a) => a.abbreviation}
                                        optionLabel={(a) => a.name}
                                    /> */}

                              <FormControl
                                variant="outlined"
                                className="custom-select-input"
                                size={"small"}
                              >
                                <InputLabel
                                  id="country"
                                  htmlFor="outlined-age-native-simple"
                                >
                                  {" "}
                                  {props.t("COUNTRY") + " *"}
                                </InputLabel>
                                <Select
                                  native
                                  label="country"
                                  labelId="country"
                                  value={details.shipping.country}
                                  onChange={(e) => {
                                    // setShipping(e);
                                    setStateListChange(
                                      e.target.value,
                                      "shipping",
                                    );
                                  }}
                                  inputProps={{
                                    name: "country",
                                    id: "country",
                                  }}
                                >
                                  {countriesList.map((a) => (
                                    <option key={a.id} value={a.id}>
                                      {a.name}
                                    </option>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 6,
                              }}
                            >
                              {/* <Select
                                        name={'state'}
                                        placeholder={'State'}
                                        label={props.t('STATE') + ' *'}
                                        onChange={(e) => {
                                            setShipping(e)
                                        }}
                                        selectClass={classes.inputClass}
                                        selected={details.shipping.state}
                                        options={details.shipping && details.shipping.country ? stateCode.state[details.shipping.country] : []}
                                        default={props.t('SELECT_STATE')}
                                        value={(a) => a.abbreviation}
                                        optionLabel={(a) => a.name}
                                    /> */}

                              <FormControl
                                variant="outlined"
                                className="custom-select-input"
                                size={"small"}
                              >
                                <InputLabel
                                  id="state"
                                  htmlFor="outlined-age-native-simple"
                                >
                                  {" "}
                                  {props.t("STATE") + " *"}
                                </InputLabel>
                                <Select
                                  native
                                  labelId="state"
                                  label="state"
                                  value={details.shipping.state}
                                  onChange={(e) => {
                                    setShipping(e);
                                    setError({
                                      ...error,
                                      state_shipping: "",
                                    });
                                  }}
                                  error={!!error.state_shipping}
                                  inputProps={{
                                    name: "state",
                                    id: "state",
                                  }}
                                >
                                  <option value={""}></option>
                                  {shippingStateList.map((a) => (
                                    <option key={a.id} value={a.id}>
                                      {a.name}
                                    </option>
                                  ))}
                                </Select>
                                {error.state_shipping && (
                                  <span
                                    style={{
                                      color: "#f44336",
                                      marginLeft: "0px",
                                      fontSize: "0.75rem",
                                      marginTop: "4px",
                                    }}
                                  >
                                    {error.state_shipping}
                                  </span>
                                )}
                              </FormControl>
                            </Grid>
                          </React.Fragment>
                        )}
                      </Grid>
                    </Grid>
                  )}
                </div>

                {activeStep === 0 && props.showMyCustomers && (
                  <>
                    <Divider variant="middle" />
                    <Grid container spacing={2} style={{ padding: "2rem" }}>
                      <Grid
                        item
                        size={{
                          xs: 12,
                        }}
                      >
                        <h3 style={{ margin: 0 }}>{t("CREATED_BY")}</h3>
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 6,
                        }}
                      >
                        <TextField
                          variant="outlined"
                          placeholder={props.t("USERNAME") + " *"}
                          name={"createdByUser"}
                          value={details.createdByUser}
                          onChange={(e) => {
                            setDetails({
                              ...details,
                              [e.target.name]: e.target.value,
                            });
                            setError({
                              ...error,
                              createdByUser: "",
                            });
                            setSuccess({
                              ...success,
                              createdByUser: "",
                            });
                            closeErrorMessage();
                          }}
                          onBlur={async () => {
                            setDetails({
                              ...details,
                              createdByUser: details.createdByUser.trim(),
                            });
                            // await verifyUserId();
                          }}
                          size="small"
                          error={!!error.createdByUser}
                          helperText={
                            error.createdByUser || success.createdByUser
                          }
                          FormHelperTextProps={{
                            className: success.createdBy
                              ? "success-helper-text"
                              : "",
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                {details.createdByUser && (
                                  <IconButton onClick={() => clearUserName()} edge="end">
                                    <ClearIcon />
                                  </IconButton>
                                )}
                                <IconButton edge="end" onClick={() => openSearchUsernameDialog()}>
                                  <SearchIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        {/* <Input
                          error={!!error.createdByUser}
                          helperText={
                            error.createdByUser || success.createdByUser
                          }
                          inputClass={classes.inputClass}
                          size={"small"}
                          name={"createdByUser"}
                          variant={"outlined"}
                          // style={{ marginTop: "15px" }}
                          placeholder={props.t("USERNAME") + " *"}
                          value={details.createdByUser}
                          onChange={(e) => {
                            setDetails({
                              ...details,
                              [e.target.name]: e.target.value,
                            });
                            setError({
                              ...error,
                              createdByUser: "",
                            });
                            setSuccess({
                              ...success,
                              createdByUser: "",
                            });
                            closeErrorMessage();
                          }}
                          onBlur={async () => {
                            setDetails({
                              ...details,
                              createdByUser: details.createdByUser.trim(),
                            });
                            // await verifyUserId();
                          }}
                          FormHelperTextProps={{
                            className: success.createdBy
                              ? "success-helper-text"
                              : "",
                          }}
                        /> */}
                      </Grid>
                    </Grid>
                  </>
                )}
              </React.Fragment>
            ) : null}
            {showUsernameDialog &&
              <SearchUsersDialog
                open={showUsernameDialog}
                onClose={onCloseUsernameDialog}
                selectUser={selectUser}
                screen={'add'}
              />
            }
            <div
              className={classes.stepButton}
              style={{ padding: "0rem 2rem 2rem" }}
            >
              {/* <label style={mandatoryMessage}>
                    {t('MANDATORY_FIELDS_MESSAGE')}
                </label> */}
              {!props.oldOrder ? (
                <>
                  {props.manageCustomer ? (
                    <>
                      <br />
                      {/* <Button onClick={() => { props.close() }}>{props.t('CANCEL')}</Button> */}
                      {props.screenType && props.screenType === "leads" ? (
                        <>
                          <Button
                            className={"buttonSecondary"}
                            onClick={() => {
                              props.close();
                            }}
                          >
                            {props.t("CANCEL")}
                          </Button>
                          <Button onClick={() => onNext(activeStep)}>
                            {props.t("SUBMIT")}
                          </Button>
                        </>
                      ) : (
                        <>
                          {activeStep > 0 ? (
                            <Button
                              className={"buttonSecondary"}
                              onClick={() => {
                                handleBack();
                              }}
                            >
                              {props.t("BACK")}
                            </Button>
                          ) : (
                            <Button
                              className={"buttonSecondary"}
                              onClick={() => {
                                props.close();
                              }}
                            >
                              {props.t("CANCEL")}
                            </Button>
                          )}
                          {modules.module_payment === "enabled" &&
                            activeStep === 2 ? (
                            <Button onClick={() => onNext(activeStep)}>
                              {props.edit
                                ? props.t("UPDATE_CUSTOMER")
                                : props.t("SUBMIT")}
                            </Button>
                          ) : modules.module_payment !== "enabled" &&
                            activeStep === 1 ? (
                            <Button onClick={() => onNext(activeStep)}>
                              {props.edit
                                ? props.t("UPDATE_CUSTOMER")
                                : props.t("SUBMIT")}
                            </Button>
                          ) : (
                            <Button onClick={() => onNext(activeStep)}>
                              {props.t("NEXT")}
                            </Button>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <Button
                        className={"buttonSecondary"}
                        onClick={() => {
                          props.back(props.stage);
                        }}
                      >
                        {props.edit ? props.t("CANCEL") : props.t("BACK")}
                      </Button>
                      <Button
                        onClick={() => {
                          onNext(activeStep);
                        }}
                      >
                        {props.edit ? props.t("UPDATE") : props.t("NEXT")}
                      </Button>
                    </>
                  )}
                </>
              ) : (
                <>
                  <Button
                    className={"buttonSecondary"}
                    onClick={() => {
                      navigate(`/order/${props.router.params.orderId}`);
                    }}
                  >
                    {props.t("CANCEL")}
                  </Button>
                  <Button
                    onClick={() => {
                      updateCustomerDetails();
                    }}
                  >
                    {t("UPDATE")}
                  </Button>
                </>
              )}
            </div>
          </Box>
        </>
      )}
      <Dialog
        maxWidth={"sm"}
        open={openDialog}
        PaperComponent={DraggableDialogPaper}
        onClose={(event) => handleClose(false)}
        aria-labelledby="customized-dialog-title"
      // PaperProps={{
      //     className: classess.resizablePaper
      // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          {t("CHOOSE_A")}&nbsp;
          {customerSelectionOptions === "payment"
            ? t("PAYMENT_METHOD")
            : customerSelectionOptions === "shipping"
              ? t("SHIPPING_ADDRESS")
              : customerSelectionOptions === "billing" && t("BILLING_ADDRESS")}
        </DialogTitle>
        <DialogContent dividers>
          <Paper className={classes.paper}>
            {customerSelectionOptions === "shipping" && (
              <AddressDetails
                tabValue="0"
                screen="checkout"
                addressDetails={shippingDetails}
                customerDetails={props.customerDetails}
                chooseExistingCustomerDetail={chooseExistingCustomerDetail}
              />
            )}
            {customerSelectionOptions === "billing" && (
              <AddressDetails
                tabValue="1"
                screen="checkout"
                addressDetails={billingDetails}
                customerDetails={props.customerDetails}
                chooseExistingCustomerDetail={chooseExistingCustomerDetail}
              />
            )}
            {customerSelectionOptions === "payment" && (
              <PaymentDetails
                tabValue="2"
                screen="checkout"
                eftAccountList={eftAccountDetails}
                creditCardList={creditCardDetails}
                customerDetails={props.customerDetails}
                chooseExistingCustomerDetail={chooseExistingCustomerDetail}
              />
            )}
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button onClick={(event) => handleClose(false)} color="primary">
            {t("CANCEL")}
          </Button>
        </DialogActions>
      </Dialog>
      {/* {open &&
                <PaymentDialog
                    open={open}
                    closeDialog={closePaymentDialog}
                />
            } */}
      <Loader loading={loading} />
      <Loader loading={partialLoading} />
    </React.Fragment>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    tenantData: state.auth.tenantData,
    loggedInUserType: state.auth.userLoginType,
    countriesList: state.global.countriesList,
    defaultCountry: state.auth.defaultCountry,
    loggedInUserId: state.auth.loggedInUserId,
    showMyCustomers: state.auth.showMyCustomers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(CustomerDetails));
